const isEnabled = (value) => ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());

const runtimeFlag = (key, buildValue) => {
    const runtimeConfig = typeof window !== 'undefined' && window.__PINNHUB_CONFIG__
        && typeof window.__PINNHUB_CONFIG__ === 'object'
        ? window.__PINNHUB_CONFIG__
        : {};
    return Object.prototype.hasOwnProperty.call(runtimeConfig, key)
        ? isEnabled(runtimeConfig[key])
        : isEnabled(buildValue);
};

export const isAgentWorkflowV2Enabled = () => runtimeFlag(
    'agentWorkflowV2Enabled',
    process.env.REACT_APP_AGENT_WORKFLOW_V2,
);

export const isTrainingEnabled = () => runtimeFlag(
    'trainingEnabled',
    process.env.REACT_APP_TRAINING_ENABLED,
);

export const isAgentEventStreamEnabled = () => (
    String(process.env.REACT_APP_AGENT_EVENT_STREAM_ENABLED || '').toLowerCase() === 'true'
);

export const isAgentWorkspaceEnabled = () => (
    String(process.env.REACT_APP_AGENT_WORKSPACE_ENABLED || '').toLowerCase() === 'true'
);

export const getEventSequence = (event) => {
    const sequence = Number(event?.sequence);
    return Number.isSafeInteger(sequence) && sequence >= 0 ? sequence : null;
};

export const mergeRunEvents = (currentEvents = [], nextEvents = []) => {
    const bySequence = new Map();
    [...currentEvents, ...nextEvents].forEach((event) => {
        const sequence = getEventSequence(event);
        if (sequence !== null && !bySequence.has(sequence)) {
            bySequence.set(sequence, event);
        }
    });
    return Array.from(bySequence.values()).sort((left, right) => (
        getEventSequence(left) - getEventSequence(right)
    ));
};

export const getLastRunEventSequence = (events = []) => events.reduce((lastSequence, event) => {
    const sequence = getEventSequence(event);
    return sequence === null ? lastSequence : Math.max(lastSequence, sequence);
}, 0);

export const workflowStatusLabel = (status) => ({
    REQUIREMENTS_PENDING: 'Requirements pending',
    PLAN_READY: 'Plan ready',
    AWAITING_PLAN_APPROVAL: 'Awaiting plan approval',
    GENERATING: 'Generating',
    VALIDATING: 'Validating',
    REPAIRING: 'Repairing',
    READY_TO_RUN: 'Ready to run',
    AWAITING_RUN_APPROVAL: 'Awaiting run approval',
    PROVISIONING: 'Provisioning',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    COLLECTING: 'Collecting artifacts',
    SUMMARIZING: 'Summarizing',
    CLEANING_UP: 'Cleaning up',
    TIMED_OUT: 'Timed out',
    CANCELLED: 'Cancelled',
    FAILED: 'Failed',
    CLEANUP_FAILED: 'Cleanup failed',
    COMPLETED: 'Completed',
    awaiting_approval: 'Awaiting approval',
    approved: 'Approved',
    running: 'Validation or training run',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
}[status] || 'Draft');
